import React from 'react';
import Box from '@mui/material/Box';

const bgSx = {
    width: '100%',
    height: '600px',
    margin: 0,
    background: '#88ccee',
    overflow: 'hidden'
};

const sceneSx = {
    position: 'relative',
    width: '100%',
    height: '100%'
};

const skySx = {
    position: 'absolute',
    top: 0,
    height: '40%',
    width: '100%',
    background: 'linear-gradient(to bottom, #a0d8ef, #b6e3c3)'
};

const groundSx = {
    position: 'absolute',
    bottom: 0,
    height: '60%',
    width: '100%',
    background: 'linear-gradient(to top, #3c763d, #4caf50)'
};

const treeSx = {
    position: 'absolute',
    bottom: '60%',
    width: '30px',
    background: '#5d4037',
    borderRadius: '8px',
    zIndex: 2,
    '&::before': {
        content: '""',
        position: 'absolute',
        bottom: '100%',
        left: '-30px',
        width: '90px',
        height: '90px',
        background: 'radial-gradient(circle, #388e3c 60%, transparent 61%)',
        borderRadius: '50%',
        zIndex: -1
    }
};

const treeSmSx = { height: '80px' };
const treeMdSx = { height: '110px' };
const treeLgSx = { height: '140px' };

const bushSx = {
    position: 'absolute',
    bottom: '60%',
    width: '60px',
    height: '30px',
    background: '#2e7d32',
    borderRadius: '50% 50% 0 0',
    zIndex: 3
};

const rockSx = {
    position: 'absolute',
    bottom: 'calc(60% - 5px)',
    width: '40px',
    height: '25px',
    background: '#666',
    borderRadius: '40% 40% 30% 30%'
};

const Background = () => (
    <Box sx={bgSx}>
        <Box sx={sceneSx}>
            <Box sx={skySx} />
            <Box sx={groundSx} />

            <Box sx={{ ...treeSx, ...treeLgSx, left: '10%' }} />
            <Box sx={{ ...treeSx, ...treeSmSx, left: '25%' }} />
            <Box sx={{ ...treeSx, ...treeMdSx, left: '40%' }} />
            <Box sx={{ ...treeSx, ...treeLgSx, right: '15%' }} />

            <Box sx={{ ...bushSx, left: '21%' }} />
            <Box sx={{ ...bushSx, right: '20%' }} />

            <Box sx={{ ...rockSx, left: '50%' }} />
            <Box sx={{ ...rockSx, right: '35%' }} />
        </Box>
    </Box>
);

export default Background;